<template>
  <div class="main-content">
    <md-layout md-column>
      <div class="blueprint">
        <img
          ref="planta"
          :src="blueprint"
          @load="calculate"
          :height="bpHeight"
          :width="bpWidth"
        ></img>
        <div
          v-for="(area,key) in certificationProcess.areas"
          :data-x="(clientWidth / certificationProcess.bpWidth) * area.x"
          :data-y="(clientHeight / certificationProcess.bpHeight) * area.y"
          :key="area['.key']"
          :class="area.structures || area.status >= 1?`notdraggable`:`draggable`"
          :data-key="key"
          :style="`-webkit-transform:translate(${(clientWidth / certificationProcess.bpWidth) * area.x}px,${(clientHeight / certificationProcess.bpHeight) * area.y}px);transform:translate(${(clientWidth / certificationProcess.bpWidth) * area.x}px,${(clientHeight / certificationProcess.bpHeight)*area.y}px);width:${(clientWidth / certificationProcess.bpWidth) * parseInt(area.w,10)+`px`}; height:${(clientHeight / certificationProcess.bpHeight) * parseInt(area.h,10)+`px`}`"
        >
          <draggableArea
            :number="key"
            :value="area"
          ></draggableArea>
          <div resize-edges="bottom right"></div>
          <div resize-edges="bottom left"></div>
          <div resize-edges="top left"></div>
          <div resize-edges="top right"></div>
          <md-tooltip
            md-direction="top"
            v-if="area.structures || area.status >=1"
          >MOVIMENTAÇÃO BLOQUEADA!
          </md-tooltip>
          <md-tooltip md-direction="bottom">CLIQUE 2X P/ ALTERAR OU EXCLUIR</md-tooltip>
        </div>
      </div>
    </md-layout>
    <md-button
      class="md-fab md-fab-bottom-right"
      @click="addArea()"
    >
      <md-icon>add</md-icon>
    </md-button>
    <add-area-dialog
      :activeProcess="certificationProcess"
      ref="add_area_dialog"
    ></add-area-dialog>
  </div>
</template>
<script>
import AddAreaDialog from '@/components/AddAreaDialog'
import DraggableArea from '@/components/DraggableArea'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'areas',
  components: {
    AddAreaDialog,
    DraggableArea
  },
  beforeDestroy() {
    this.$interact('.draggable').unset()
    this.$interact('.notdraggable').unset()
  },
  computed: {
    ...mapState({
      'certificationProcess': state => state.certificationProcess
    })
  },
  updated() {
    this.$nextTick(() => {
      if (this.loaded) {
        this.calculate()
      }
    })
  },
  data: () => ({
    blueprint: '',
    bpHeight: 0,
    bpWidth: 0,
    deviceWidth: 0,
    clientWidth: 0,
    clientHeight: 0,
    deviceHeight: 0,
    selected: null,
    loaded: false,
    ratio: 1
  }),
  mounted() {
    this.calculate()
  },
  beforeMount() {
    this.FETCH_DATA().then(() => {
      // if (this.certificationProcess.blueprintUrl) {
      //   this.bpWidth = this.certificationProcess.bpWidth
      //   this.bpHeight = this.certificationProcess.bpHeight
      //   this.blueprint = this.certificationProcess.blueprintUrl
      //   this.deviceWidth = this.certificationProcess.deviceWidth
      //   this.deviceHeight = this.certificationProcess.deviceHeight
      //   this.setInteractive()
      // } else {
      this.FETCH_IMAGE(this.certificationProcess.blueprint).then(imageBlob => {
        this.loadBlueprint(imageBlob)
      }).catch((error) => {
        console.log(error)
      })
      // }
    })
    window.dragMoveListener = this.dragMoveListener
  },
  methods: {
    ...mapActions([
      'FETCH_DATA',
      'FETCH_IMAGE',
      'SET_AREA',
      'SET_PROCESS'
    ]),
    calculate() {
      this.clientWidth = this.$refs.planta.clientWidth
      this.clientHeight = this.$refs.planta.clientHeight
    },
    select(area) {
      if (this.selected) {
        this.selected.classList.remove('selected')
      }
      this.selected = area
      this.selected.classList.add('selected')
    },
    deselect() {
      if (this.selected) {
        this.selected.classList.toggle('selected')
        this.selected = null
      }
    },
    setInteractive() {
      var vm = this
      this.$interact('.draggable').unset()
      this.$interact('.notdraggable').unset()
      vm.$interact('.notdraggable').on('doubletap', event => {
        let target = event.target
        let key = target.getAttribute('data-key')
        let currentArea = vm.certificationProcess.areas[key]
        vm.$refs.add_area_dialog.edit(currentArea, key)
        event.preventDefault()
      }).on('tap', event => {
        if (!event.selectDone) {
          event.selectDone = true
          vm.select(event.currentTarget)
        }
      })
      vm.$interact('.draggable').draggable({
        inertia: false,
        max: Infinity,
        restrict: {
          restriction: 'parent',
          elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
        },
        autoScroll: false,
        onstart: (event) => {
          console.log('on start event')
          vm.select(event.currentTarget)
        },
        onmove: vm.dragMoveListener,
        onend: vm.endMoveListener
      })
        .resizable({
          preserveAspectRatio: false,
          invert: 'reposition',
          edges: {
            left: '[resize-edges~=left]',
            right: '[resize-edges~=right]',
            bottom: '[resize-edges~=bottom]',
            top: '[resize-edges~=top]'
          },
          onmove: vm.resizeMoveListener,
          onend: vm.resizeEndListener
        })
        .on('doubletap', event => {
          let target = event.target
          let key = target.getAttribute('data-key')
          let currentArea = vm.certificationProcess.areas[key]
          vm.$refs.add_area_dialog.edit(currentArea, key)
          event.preventDefault()
        }).on('tap', event => {
          if (!event.selectDone) {
            event.selectDone = true
            vm.select(event.currentTarget)
          }
        })
    },
    addArea() {
      this.$refs.add_area_dialog.open()
    },
    loadBlueprint(imageBlob) {
      var vm = this
      let fileReader = new FileReader()
      fileReader.onload = function(e) {
        vm.blueprint = e.target.result
        var img = new Image()
        img.src = vm.blueprint
        img.onload = () => {
          let ratio = Math.min(window.innerWidth / img.width, (window.innerHeight) / img.height)
          vm.bpWidth = Math.round(img.width * ratio)
          vm.bpHeight = Math.round(img.height * ratio)
          vm.$set(vm.certificationProcess, 'bpWidth', vm.bpWidth)
          vm.$set(vm.certificationProcess, 'bpHeight', vm.bpHeight)
          vm.$set(vm.certificationProcess, 'deviceWidth', window.innerWidth)
          vm.$set(vm.certificationProcess, 'deviceHeight', window.innerHeight)
          vm.SET_PROCESS(vm.certificationProcess)
          vm.setInteractive()
        }
      }
      fileReader.readAsDataURL(imageBlob)
    },
    resizeMoveListener(event) {
      let target = event.target
      let x = (parseFloat(target.getAttribute('data-x')) || 0)
      let y = (parseFloat(target.getAttribute('data-y')) || 0)

      // update the element's style
      target.style.width = event.rect.width + 'px'
      target.style.height = event.rect.height + 'px'

      // translate when resizing from top or left edges
      x += event.deltaRect.left
      y += event.deltaRect.top

      target.style.webkitTransform = target.style.transform =
        'translate(' + x + 'px,' + y + 'px)'

      target.setAttribute('data-x', x)
      target.setAttribute('data-y', y)
    },
    dragMoveListener(event) {
      let target = event.target
      // keep the dragged position in the data-x/data-y attributes
      let x = (parseFloat(target.getAttribute('data-x')) || 0)
      x += event.dx
      let y = (parseFloat(target.getAttribute('data-y')) || 0)
      y += event.dy
      // translate the element
      target.style.webkitTransform =
        target.style.transform =
          'translate(' + x + 'px, ' + y + 'px)'

      // update the posiion attributes
      target.setAttribute('data-x', x)
      target.setAttribute('data-y', y)
    },
    resizeEndListener(event) {
      let target = event.target
      let key = target.getAttribute('data-key')
      let w = event.rect.width
      let wScaled = w / (this.clientWidth / this.certificationProcess.bpWidth)
      let h = event.rect.height
      let hScaled = h / (this.clientHeight / this.certificationProcess.bpHeight)

      let x = (parseFloat(target.getAttribute('data-x')) || 0)
      let xScaled = x / (this.clientWidth / this.certificationProcess.bpWidth)
      let y = (parseFloat(target.getAttribute('data-y')) || 0)
      let yScaled = y / (this.clientHeight / this.certificationProcess.bpHeight)
      let currentArea = this.certificationProcess.areas[key]

      currentArea.vertices = this.calculateVertices(xScaled, yScaled, wScaled, hScaled) // ????

      currentArea.w = wScaled
      currentArea.h = hScaled
      currentArea.x = xScaled
      currentArea.y = yScaled

      this.SET_AREA({ area: currentArea, key: key })
    },
    endMoveListener(event) {
      let target = event.target
      let key = target.getAttribute('data-key')
      let x = (parseFloat(target.getAttribute('data-x')) || 1)
      let xScaled = x / (this.clientWidth / this.certificationProcess.bpWidth)
      let y = (parseFloat(target.getAttribute('data-y')) || 1)
      let yScaled = y / (this.clientHeight / this.certificationProcess.bpHeight)

      let currentArea = this.certificationProcess.areas[key]

      currentArea.vertices = this.calculateVertices(xScaled, yScaled, currentArea.w, currentArea.h) // ????

      currentArea.x = xScaled
      currentArea.y = yScaled

      this.SET_AREA({ area: currentArea, key: key })
    },
    calculateVertices(areaX, areaY, areaW, areaH) {
      var vertices = []
      let margem = 11
      // top left
      let v0 = {
        id: 0,
        x: areaX,
        y: areaY,
        photos: [
          { name: 'Chão', description: 'Fique em frente ao vértice e aponte para o chão', image: '' },
          { name: 'Teto', description: 'Fique em frente ao vértice e aponte para o teto', image: '' },
          { name: 'Vértice Oposto', description: 'Aponte para o vertice oposto', image: '' }
        ],
        type: 'vertice',
        name: 'Vértice Superior Esquerdo'
      }
      // top right
      let v1 = {
        id: 1,
        x: parseInt(areaW, 10) + areaX - margem,
        y: areaY,
        photos: [
          { name: 'Chão', description: 'Fique em frente ao vértice e aponte para o chão', image: '' },
          { name: 'Teto', description: 'Fique em frente ao vértice e aponte para o teto', image: '' },
          { name: 'Vértice Oposto', description: 'Aponte para o vertice oposto', image: '' }
        ],
        type: 'vertice',
        name: 'Vértice Superior Direito'
      }
      // bottom right
      let v2 = {
        id: 2,
        x: parseInt(areaW, 10) + areaX - margem,
        y: parseInt(areaH, 10) + areaY - margem,
        photos: [
          { name: 'Chão', description: 'Fique em frente ao vértice e aponte para o chão', image: '' },
          { name: 'Teto', description: 'Fique em frente ao vértice e aponte para o teto', image: '' },
          { name: 'Vértice Oposto', description: 'Aponte para o vertice oposto', image: '' }
        ],
        type: 'vertice',
        name: 'Vértice Inferior Direito'
      }
      // bottom left
      let v3 = {
        id: 3,
        x: areaX,
        y: parseInt(areaH, 10) + areaY - margem,
        photos: [
          { name: 'Chão', description: 'Fique em frente ao vértice e aponte para o chão', image: '' },
          { name: 'Teto', description: 'Fique em frente ao vértice e aponte para o teto', image: '' },
          { name: 'Vértice Oposto', description: 'Aponte para o vertice oposto', image: '' }
        ],
        type: 'vertice',
        name: 'Vértice Inferior Esquerdo'
      }
      vertices.push(v0)
      vertices.push(v1)
      vertices.push(v2)
      vertices.push(v3)
      return vertices
    }
  }
}
</script>
<style scoped>
.md-title,
.md-caption {
  padding: 8px;
}

.blueprint,
.blueprint > img {
  /* -ms-touch-action: none;
  touch-action: none; */
  display: flex;

  /*  */
}

.blueprint.img {
  z-index: -999999;
}

.draggable.selected {
  border-style: dotted;
}

.notdraggable {
  background-color: rgba(214, 166, 6, 0.8);
  opacity: 0, 7;
  width: 100px;
  height: 100px;

  -webkit-transform: translate(0px, 0px);
  transform: translate(0px, 0px);
  /* This makes things *much* easier */
  box-sizing: border-box;
  -ms-touch-action: none;
  touch-action: none;
  border-radius: 8px;
  position: absolute;
  /* bottom: 20%;
  right: 10%; */
  z-index: 99999999;
}

.draggable {
  background-color: rgba(63, 81, 181, 0.8);
  opacity: 0, 7;
  width: 100px;
  height: 100px;

  -webkit-transform: translate(0px, 0px);
  transform: translate(0px, 0px);
  /* This makes things *much* easier */
  box-sizing: border-box;
  -ms-touch-action: none;
  touch-action: none;
  border-radius: 8px;
  position: absolute;
  /* bottom: 20%;
  right: 10%; */
  z-index: 99999999;
}

[resize-edges] {
  visibility: hidden;
}

.selected > [resize-edges] {
  visibility: visible;
  width: 20px;
  height: 20px;
  border-style: solid;
  background-color: rgba(255, 255, 255, 0.5);
  z-index: 999999999;
}

[resize-edges~="bottom"] {
  position: absolute;
  bottom: -10px;
}

[resize-edges~="top"] {
  position: absolute;
  top: -10px;
}

[resize-edges~="right"] {
  position: absolute;
  right: -10px;
}

[resize-edges~="left"] {
  position: absolute;
  left: -10px;
}

.md-list {
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// AreaView.vue?17f8921a